import { useState, useCallback } from "react";
import ArrowLeft from "../Icons/ArrowLeft";
import ArrowRight from "../Icons/ArrowRight";
import Slider from "react-slick";
import Link from "next/link";
import CarouselItem from "../Items/carouselItem";
import Arrow from "../Icons/Arrow";
import ChurchCarouselItem from "components/Items/churchCarouselItem";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const churchResArray = [
  {
    breakpoint: 3800,
    settings: {
      slidesToShow: 12,
      slidesToScroll: 12,
    },
  },
  {
    breakpoint: 3535,
    settings: {
      slidesToShow: 11,
      slidesToScroll: 11,
    },
  },
  {
    breakpoint: 3225,
    settings: {
      slidesToShow: 10,
      slidesToScroll: 10,
    },
  },
  {
    breakpoint: 2925,
    settings: {
      slidesToShow: 9,
      slidesToScroll: 9,
    },
  },
  {
    breakpoint: 2650,
    settings: {
      slidesToShow: 8,
      slidesToScroll: 8,
    },
  },
  {
    breakpoint: 2400,
    settings: {
      slidesToShow: 7,
      slidesToScroll: 7,
    },
  },
  {
    breakpoint: 1800,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 6,
    },
  },
  {
    breakpoint: 1300,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  },
  {
    breakpoint: 1100,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
];

const resArray = [
  {
    breakpoint: 3800,
    settings: {
      slidesToShow: 9,
      slidesToScroll: 9,
    },
  },
  {
    breakpoint: 3425,
    settings: {
      slidesToShow: 8,
      slidesToScroll: 8,
    },
  },
  {
    breakpoint: 3050,
    settings: {
      slidesToShow: 7,
      slidesToScroll: 7,
    },
  },
  {
    breakpoint: 2665,
    settings: {
      slidesToShow: 6,
      slidesToScroll: 6,
    },
  },
  {
    breakpoint: 2285,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 5,
    },
  },
  {
    breakpoint: 1300,
    settings: {
      slidesToShow: 4,
      slidesToScroll: 4,
    },
  },
];

const NewCarousel = ({
  header,
  data,
  isLive = false,
  link,
  upcomingEvent = false,
  isChurch = false,
}) => {
  const SampleNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} ${
          isChurch
            ? "!h-[383px] !top-12 desktop:!h-[320px]"
            : "!h-236 !top-12 desktop:!h-179"
        } !w-[38px] !right-0 !bg-black !opacity-80 !flex items-center justify-center z-[1] !transform-none `}
        style={style}
        onClick={onClick}
      >
        <ArrowRight />
      </div>
    );
  };

  const SamplePrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={`${className} ${
          isChurch
            ? "!h-[383px] !top-12 desktop:!h-[320px]"
            : "!h-236 !top-12 desktop:!h-179"
        } !w-[38px] !left-0 !bg-black !opacity-80 !flex items-center justify-center z-[1] !transform-none `}
        style={style}
        onClick={onClick}
      >
        <ArrowLeft />
      </div>
    );
  };

  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: isChurch ? 13 : 10,
    slidesToScroll: isChurch ? 13 : 10,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: isChurch ? churchResArray : resArray,
  };

  const [dragging, setDragging] = useState(false);

  const handleBeforeChange = useCallback(() => {
    setDragging(true);
  }, [setDragging]);

  const handleAfterChange = useCallback(() => {
    setDragging(false);
  }, [setDragging]);

  const handleOnItemClick = useCallback(
    (e) => {
      if (dragging) e.stopPropagation();
    },
    [dragging]
  );

  return (
    <section className="w-full tablet-100:hidden">
      <header className="flex items-center">
        <h2
          className={
            isLive
              ? "text-xl font-medium pl-14 flex items-center"
              : "text-xl font-medium pl-14 flex items-center pr-12"
          }
        >
          {header}{" "}
        </h2>
        {isLive ? (
          <>
            {" "}
            <div className="bg-red rounded-full max-w-redDot w-full h-16 ml-2"></div>
          </>
        ) : link ? (
          <>
            <Link href={`/${link}`}>
              <a className="text-bodyText text-lightGray flex items-center tablet-100:text-[17px]">
                <span className="pr-3.5">Katso kaikki</span>{" "}
                <Arrow color={"#7d7d7d"} />
              </a>
            </Link>
          </>
        ) : (
          <></>
        )}
      </header>
      <div className="flex relative overflow-x-hidden overflow-y-visible">
        <div className="w-full">
          <ul className="list-none">
            <Slider
              beforeChange={handleBeforeChange}
              afterChange={handleAfterChange}
              className={
                isChurch
                  ? "h-[640px] desktop:h-[580px]"
                  : "h-[500px] desktop:h-[430px]"
              }
              {...settings}
            >
              {data.map((itemData, i) => (
                <div
                  className="mt-12"
                  onClickCapture={handleOnItemClick}
                  key={itemData?._id}
                >
                  {isChurch ? (
                    <ChurchCarouselItem
                      idx={i}
                      position={i}
                      itemData={itemData}
                    />
                  ) : (
                    <CarouselItem
                      upcomingEvent={upcomingEvent}
                      position={i}
                      itemData={itemData}
                      isLive={isLive}
                    />
                  )}
                </div>
              ))}
            </Slider>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default NewCarousel;
